// package imports:
import React from "react";
// component imports:
import Entrypoint from "../Entrypoint";
import OlderDataPage from "../../components/DueDiligence/OlderDataPage";
import { OlderDataViewModel } from "../../types/DueDiligenceTypes";

const OlderData: React.FC<OlderDataViewModel> = ({customerId, warningMessage, company, user}) => {
    return (
        <Entrypoint>
            <OlderDataPage 
                customerId={customerId} 
                warningMessage={warningMessage} 
                company={company} 
                user={user} 
            />
        </Entrypoint>
    );
}

export default OlderData;